export default {
    namespaced: true,
    state: {
		title: '',
		params: {
			datebegin: null,
			dateend: null,
		},
        data: {
			datasets: {
				ds: {},
				ds2: {},
			}
		},
    },
}